import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "flex items-center" }, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "capitalize text-primary font-bold overflow-ellipsis overflow-hidden whitespace-nowrap" }, "Settings"),
    /*#__PURE__*/ _createElementVNode("span", { class: "fas fa-crown text-xs ml-2" })
], -1);
const _hoisted_2 = { class: "w-full h-full flex flex-row -ml-2 px-2" };
const _hoisted_3 = { class: "flex flex-col md:w-80 w-full h-full items-center md:border-r" };
const _hoisted_4 = { class: "flex flex-row items-center" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("em", { class: "text-xl text-primary fas fa-cogs fa-fw opacity-50" }, null, -1);
const _hoisted_6 = { class: "capitalize font-bold ml-3 text-lg overflow-ellipsis overflow-hidden whitespace-nowrap" };
const _hoisted_7 = { class: "text-gray-600 text-sm font-light" };
const _hoisted_8 = { class: "flex flex-row items-center" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("em", { class: "text-xl text-primary fas fa-sliders-h fa-fw opacity-50" }, null, -1);
const _hoisted_10 = { class: "capitalize ml-3 font-bold text-lg overflow-ellipsis overflow-hidden whitespace-nowrap" };
const _hoisted_11 = { class: "text-gray-600 text-sm font-light" };
const _hoisted_12 = { class: "flex flex-col w-full h-full items-left ml-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_router_view = _resolveComponent("router-view");
    const _component_tab_layout = _resolveComponent("tab-layout");
    return (_openBlock(), _createBlock(_component_tab_layout, null, {
        title: _withCtx(() => [
            _hoisted_1
        ]),
        content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_router_link, {
                        class: _normalizeClass(["p-3 w-full h-auto justify-start border-b hover:bg-blue-50", [_ctx.$route.matched.some(route => route.name === 'GlobalSettings') ? 'bg-blue-50' : '']]),
                        to: { name: 'GlobalSettings' }
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('settings.globalTitle')), 1)
                            ]),
                            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t('settings.globalSubtitle')), 1)
                        ]),
                        _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                        class: _normalizeClass(["p-3 w-full h-auto justify-start border-b hover:bg-blue-50", [_ctx.$route.matched.some(route => route.name === 'BrandingSettings') ? 'bg-blue-50' : '']]),
                        to: { name: 'BrandingSettings' }
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('settings.brandingTitle')), 1)
                            ]),
                            _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.$t('settings.brandingSubtitle')), 1)
                        ]),
                        _: 1
                    }, 8, ["class"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_router_view)
                ])
            ])
        ]),
        _: 1
    }));
}
